export default "__VITE_ASSET__iQMyO7Wp__"